// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"794288ea","170":"2a7a10f9","219":"d33d9f02","824":"1c35f2c4"}[chunkId] + ".chunk.js";
};